import { request } from "@/utils/request";

// 获取用户数据
export function getUserData() {
  return request({
    url: "/employee/employee/1.0/info",
    method: "POST",
  });
}
